import { Component, OnInit } from '@angular/core';
import { DownloadFormat, HttpMethod } from 'app/_services/download/download.enumeration';
import { DownloadService } from 'app/_services/download/download.service';


@Component({
    selector: 'app-devtestpage',
    templateUrl: './devtestpage.component.html',
    styleUrls: ['./devtestpage.component.scss'],
})
export class DevTestPageComponent implements OnInit {
    IsDevSite = true;

    constructor(private downloadService: DownloadService) 
    { }

    ngOnInit(): void {}

    
    // #region Download PDF Method - This method downloads a variety of PDFs related to the application.

    DownloadCalendarPDF(event: Event) {
        if (event) event.preventDefault();

        const self = this;

        const startDate = '07-01-2016';
        const endDate = '09-09-2022';
        const approvalDate = '01-26-2021';

        console.log('startDate', startDate);
        console.log('endDate', endDate);

        // Download the terms and conditions.
        self.downloadService.RetrieveDownload(
            HttpMethod.GET,
            'api/SchoolCalendarPDF/schoolcalendarpdf', 
            {
                // AuthToken: self.User?.AuthToken,
                // CurrentRole: self.User?.CurrentRole,
                // PathwaysReferralID: self.Application.PathwaysReferralID,                
                SchoolYear: '2021-2022',
                SchoolYearStart: startDate,
                SchoolYearEnd: endDate,
                ApprovalDate: approvalDate,
                Category: 'Traditional',
                Attachment: true
            }, 
            DownloadFormat.PDF
        ).subscribe(
        () => {
        }, (errorMsg: string) => {
            console.error(errorMsg);
        });
    }

    // #endregion
}
